import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'azureName' })
export class AzureNamePipe implements PipeTransform {
  transform(value: string | null | undefined): string {

    if (value) {
      return value.replaceAll("(CSCO)", "");
    } else {
      return '';
    }
  }
}